import { render, staticRenderFns } from "./add-panic-first.vue?vue&type=template&id=4048fd98"
import script from "./add-panic-first.vue?vue&type=script&lang=ts"
export * from "./add-panic-first.vue?vue&type=script&lang=ts"
import style0 from "./add-panic-first.vue?vue&type=style&index=0&id=4048fd98&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports